<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>
<button class="btn btn-primary btn-icon scroll-to-top" [ngClass]="{ 'show-scroll-to-top': windowScrolled }"
    type="button" (click)="scrollToTop()" rippleEffect>
    <i class="mdi mdi-arrow-up"></i>
</button>